import React, { Component } from 'react';
import server from '../server';

class Cabinet extends Component {

  state = {
    loading: true,
    page: {}
  }

  componentDidMount() {
    const uri = this.props.route.match.url;

    fetch(server.uri+'page'+uri, server.params)
      .then(response => response.json())
      .then(data =>
        this.setState({ page: data })
      );
  }
  
  render() {

    if( this.loading ) return <div className="loading"></div>;
    
    const page = this.state.page;
    
    return (
      <article className="page-article">
        <header className="main__header">
          <h1 className="main__title"><span>{page.pagetitle}</span></h1>
        </header>
        <section className="main__content">
          <div dangerouslySetInnerHTML={{ __html: page.content && page.content }}></div>
        </section>
      </article>
    );
  }
}
export default Cabinet;
